export default {
  PASSENGERS_REQUEST: 'PASSENGERS_REQUEST',
  PASSENGERS_SUCCESS: 'PASSENGERS_SUCCESS',
  PASSENGERS_FAILURE: 'PASSENGERS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/redux/constants/PassengersConstants.js